import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import _ from 'lodash';
import _str from 'underscore.string';
import { SIMPLE_VALUE_PROP } from 'ui/consts/prop-types';
import Popover from 'ui/components/popover';
import { validateField } from 'ui/utils/input-helper';
import { wireValue } from 'ui/hoc/prop-wire';

var log = require('loglevel').getLogger('core/components/input');
/**
 * A React (text) Input. Note this is wrapper around react builtin input element, major differences are:
 *
 * * Provides validation tooltip (optional)
 * * Only fire onChange event when the field has lost focus
 *
 * @constructor
 * @param {string} [id] - Input element #id
 * @param {string} [name] - Input element name
 * @param {'text'|'number'|'integer'} [type='text'] - Input type, default to 'text', if type='number' or 'integer' will trigger validation
 * @param {function} [formatter] - Input value display formatter
 * @param {string} formatter.value - currently entered input
 * @param {object} [validate] - Validation config
 * @param {number} validate.min - minimum value when type='number' or 'integer'
 * @param {number} validate.max - maximum value when type='number' or 'integer'
 * @param {RegExp|string} validate.pattern - RegExp string to test against when type='text'
 * @param {string} validate.patternReadable - Readable pattern string
 * @param {fuction} [validate.t] - Transform/translate error into readable message.<br>
 * If not specified, error message will be `${value} ${code}`<br>
 * For example see [i18next]{@link http://i18next.com/translate/} translator for generating error message.<br>
 * @param {'missing'|'no-match'|'not-int'|'not-num'|'out-of-bound'} validate.t.code - Error code
 * @param {object} validate.t.params - Parameters relevant to the error code
 * @param {string} validate.t.params.field - offending field name/id
 * @param {string} validate.t.params.value - offending field value
 * @param {RegExp|string} [validate.t.params.pattern] - pattern the value was supposed to follow
 * @param {number} [validate.t.params.min] - configured minimum value
 * @param {number} [validate.t.params.max] - configured maximum value
 * @param {string} [className] - Classname for the input
 * @param {string|number} [defaultValue] - Default value
 * @param {string|number} [value] - Current value
 * @param {object} [valueLink] - Link to update value. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} valueLink.value - value to update
 * @param {function} valueLink.requestChange - function to request value change
 * @param {boolean} [required=false] - Is this field mandatory? If true will trigger validation.
 * @param {boolean} [disabled=false] - Is this field disabled?
 * @param {boolean} [readOnly=false] - Is this field readonly?
 * @param {string} [maxLength] - Maximum input length
 * @param {string} [placeholder] - Placeholder for input
 * @param {function} [onChange] - Callback function when value is changed. <br> Required when value prop is supplied
 * @param {string|number} onChange.value - updated value
 * @param {object} onChange.eventInfo - event related info
 * @param {string|number} onChange.eventInfo.before - previous value
 *
 * @example
// controlled

import Input from 'core/components/input'
React.createClass({
    getInitialState() {
        return {
            name:'',
            age:'',
            email:''
        }
    },
    handleChange(field,value) {
        this.setState({[field]:value})
    },
    render() {
        let {name, age, email} = this.state;
        return <div className='pure-form-aligned'>
            <div className='pure-control-group'>
                <label htmlFor='name'>Name</label>
                <Input id='name'
                    onChange={this.handleChange.bind(this,'name')}
                    value={name}
                    required={true}
                    placeholder='Your name'/>
            </div>
            <div className='pure-control-group'>
                <label htmlFor='age'>Age</label>
                <Input id='age'
                    type='number'
                    validate={{
                        max:100,
                        t:(code, {value})=>`Age ${value} is invalid`
                    }}
                    className='my-age'
                    onChange={this.handleChange.bind(this,'age')}
                    value={age}
                    placeholder='Your age'/>
            </div>
            <div className='pure-control-group'>
                <label htmlFor='email'>Email</label>
                <Input id='email'
                    validate={{
                        pattern:/^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        patternReadable:'xxx@xxx.xxx',
                        t:(code, {value,pattern})=>{
                            if (code==='missing') {
                                return 'You didn\'t enter an email address'
                            }
                            else { // assume pattern issue
                                return `You didn't provide a valid email, the correct format should be ${pattern}`
                            }
                        }
                    }}
                    onChange={this.handleChange.bind(this,'email')}
                    value={email}/>
            </div>
        </div>
    }
})
 */


var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input(props, context) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, props, context); // let {value} = props

    _defineProperty(_assertThisInitialized(_this), "blurHandler", function (evt) {
      var oldVal = _this.props.value;
      var _this$state = _this.state,
          error = _this$state.error,
          newVal = _this$state.value;

      if (error) {
        if (!_this.nextTime) {
          _this.nextTime = true;

          _this.setState({
            value: oldVal
          });

          _this.input.focus();
        } else {
          _this.nextTime = false;
          Popover.close();

          _this.setState({
            error: _this.validateInput(evt.target.value) !== null
          });
        }
      } else {
        if (oldVal !== newVal) {
          var _this$props = _this.props,
              formatter = _this$props.formatter,
              onChange = _this$props.onChange;

          if (newVal != null && !_str.isBlank(newVal) && formatter && _.isFunction(formatter)) {
            newVal = formatter(newVal);
          }

          onChange(newVal);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeHandler", function (evt) {
      var newVal = evt.target.value;

      var error = _this.validateInput(newVal);

      _this.nextTime = false;

      if (error) {
        evt.stopPropagation();
        evt.preventDefault();
        Popover.open(evt, error);

        _this.setState({
          error: error,
          value: newVal
        });
      } else {
        Popover.close();

        _this.setState({
          value: newVal,
          error: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (evt) {
      if (evt.keyCode === 13) {
        _this.blurHandler(evt);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function (value) {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          id = _this$props2.id,
          type = _this$props2.type,
          required = _this$props2.required,
          validate = _this$props2.validate;
      var error = validateField(value, _objectSpread({
        name: name || id,
        type: type,
        required: required
      }, validate)); // {code:params}

      if (error) {
        var message = error.message;
        return /*#__PURE__*/React.createElement("span", null, message);
      } else {
        return null;
      }
    });

    _this.state = {
      value: '',
      error: null
    };
    return _this;
  }

  _createClass(Input, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Popover.close();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.value;
      this.setState({
        value: value,
        error: this.validateInput(value)
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (!_.isEqual(nextProps, this.props) || !_.isEqual(nextState, this.state)) return true;
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          id = _this$props3.id,
          name = _this$props3.name,
          type = _this$props3.type,
          disabled = _this$props3.disabled,
          readOnly = _this$props3.readOnly,
          placeholder = _this$props3.placeholder,
          maxLength = _this$props3.maxLength;
      var _this$state2 = this.state,
          value = _this$state2.value,
          error = _this$state2.error;
      var changeHandler = this.changeHandler;

      switch (type) {
        default:
          return /*#__PURE__*/React.createElement("input", {
            id: id,
            name: name,
            ref: function ref(_ref) {
              _this2.input = _ref;
            },
            type: type === 'password' ? 'password' : 'text'
            /* {type}*/

            /* min={min}
            max={max}
            step={step}
            pattern={pattern}
            required={required}*/
            ,
            readOnly: readOnly,
            disabled: disabled,
            maxLength: maxLength,
            onChange: changeHandler,
            onBlur: this.blurHandler,
            onKeyUp: this.keyHandler,
            placeholder: placeholder,
            className: cx(className, {
              invalid: error
            }),
            autoComplete: "new-password",
            value: value
          });
      }
    }
  }]);

  return Input;
}(React.Component);

_defineProperty(Input, "defaultProps", {
  type: 'text',
  validate: {},
  required: false,
  disabled: false,
  readOnly: false
});

_defineProperty(Input, "propTypes", {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(['text', 'number', 'integer', 'password']),
  formatter: PropTypes.func,
  validate: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
    pattern: PropTypes.oneOfType([PropTypes.instanceOf(RegExp), PropTypes.string]),
    patternReadable: PropTypes.string,
    t: PropTypes.func
  }),
  className: PropTypes.string,
  value: SIMPLE_VALUE_PROP,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  maxLength: PropTypes.number,
  placeholder: SIMPLE_VALUE_PROP,
  onChange: PropTypes.func
});

export default wireValue(Input);